import {Injectable} from '@angular/core';
import {environment} from "../../../../../../environments/environment";
import {Observable} from "rxjs";
import {Regions} from "../../../../Shared/Models/Regions";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Districts} from "../../../../Shared/Models/Districts";
import {Employers} from "../../../../Shared/Models/Employers";
import {Banks} from "../../../../hli/Shared/Models/banks";
import {AccountLookUpResponse} from "../../../Shared/Models/AccountLookUpResponse";

@Injectable({
  providedIn: 'root'
})
export class SimpleGetUtilsService {
  public refund_service_url: string = environment.refund_service_url;

  constructor(private http: HttpClient) {
  }

  public getAllRegions(): Observable<Regions[]> {
    return this.http.get<Regions[]>(`${this.refund_service_url}/shared-refund-app/get-regions/`);
  }

  public getDistrictsByRegionId(regionId: number): Observable<Districts[]> {
    const params: HttpParams = new HttpParams().set('region_id', regionId);
    return this.http.get<Districts[]>(`${this.refund_service_url}/shared-refund-app/get-districts-by-region-id/`, {params})
  }

  public getAllBanks(): Observable<Banks[]> {
    return this.http.get<Banks[]>(`${this.refund_service_url}/shared-refund-app/get-all-banks/`);
  }

  public lookUpAccount(bank_name: string, account_no: string): Observable<AccountLookUpResponse> {
    const params: HttpParams = new HttpParams().set('account_no', account_no).set('bank_name', bank_name)
    return this.http.get<AccountLookUpResponse>(`${this.refund_service_url}/shared-refund-app/account-look-up/`, {params});
  }

}
